export const baseModalTitles = {
  baseModalTitleProfileUser: "用户资料",
  baseModalTitleMobilePayment: "充值游戏币",
  baseModalTitleInviteFriend: "邀请好友",
  baseModalTitleChangePassword: "修改密码",
  baseModalTitleWithdrawal: "提现",
  baseModalTitleTransfer: "转账",
  baseModalTitleRegistration: "注册",
  baseModalTitleSupport: "支持",
};
